import React from "react";
import "./Radio.scss";
import PropTypes from "prop-types";

function Radio(props) {
  return (
    <div>
      <input
        onChange={props.onChange}
        type="radio"
        id={props.id}
        name={props.name}
        checked={props.checked}
        onClick={props.onClick}
        disabled={props.disabled}
      />
      <label htmlFor={props.id} onClick={props.onClick} disabled={props.disabled}>
        {props.label}
      </label>
    </div>
  );
}

export default Radio;

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string
};
